// extracted by mini-css-extract-plugin
module.exports = {"main":"StatusUserNotAvailable_main__x4bnI","icon":"StatusUserNotAvailable_icon__GVAMD","text":"StatusUserNotAvailable_text__dOYZn"};